//import services from './services.js';
import NProgress from 'nprogress';
import $http from '$http';
import { cloneDeep, util, isCorrectVal, isDate, lg } from 'utils';
import areaSelect from 'area-select';
import viewPhoto from 'src/common/js/viewPhoto';

export default {
    //mixins: [services],
    components: {
        areaSelect
    },
    props: {},
    computed: {
        SchoolPicsCtnId() {
            return 'SchoolPicsCtnId-' + new Date().getTime();
        },
        SchoolPicsBtnId() {
            return 'SchoolPicsBtnId-' + new Date().getTime();
        },
        LicencePicsCtnId() {
            return 'LicencePicsCtnId-' + new Date().getTime();
        },
        LicencePicsBtnId() {
            return 'LicencePicsBtnId-' + new Date().getTime();
        }
    },
    data() {
        return {
            btnLoading: false,
            checkedApplyPic: "",
            SubjectList: [], //项目类型
            isAdd: false,
            isUpdate: false,
            isReadonly: false,
            dialogVisible: false,
            agentVisible: true,
            address: this.initArea(),
            ProjectType: [], //项目类型
            form: this.initFormData(),
            seldisabled: false
        }
    },
    methods: {
        initArea() {
            return cloneDeep({
                Provinces_Id: "",
                City_Id: "",
                Area_Id: ""
            });
        },
        initFormData() {
            return cloneDeep({
                "SchoolName": "",
                "PrincipalName": "",
                "SchoolId": "",
                "CooperationPicsList": [],
                "SchoolAddress": "",
                "SchoolPriceTypeName": "",
                "PhoneNo": "",
                "CoopAgreePic_DrawingList": [],
                "Consignee": "",
                "ConsigneeTel": ""
            });
        },
        show(options) {
            let opts = $.extend({}, {
                Id: "",
                isReadonly: false
            }, options);
            this.dialogVisible = true;
            this.isReadonly = opts.isReadonly;
            this.loadData(opts.Id);

        },
        loadData(Id, callback) {
            let Params = { Sid: this.$store.state.sysSid, Session: this.$store.state.sysSession, Id: Id };
            let $msg = this.$message({
                message: '正在获取数据，请稍后...',
                duration: 0
            });

            //GET /api/School/GetSchoolCoopAgreeById
            $http.get("api/School/GetSchoolCoopAgreeById", Params).then(res => {
                $msg.close();
                util.doResult(this, res, () => {

                    let { Data } = res.data;

                    this.form = cloneDeep($.extend({}, this.initFormData(), util.filterAndSetData(this.initFormData(), Data)));

                    if (typeof callback == "function") {
                        callback();
                    }
                });
            });
        },
        updateFn() {

        },
        showImgView(img) {
            viewPhoto.show({
                showImgId: "", //指定id显示图片
                thumbList: [{
                    src: img.Url,
                    id: ""
                }]
            });
        },
        delC_Drawing(list, i) {
            list.splice(i, 1);
        },
        resetForm() {
            this.address = this.initArea();
            this.form = this.initFormData();
        },
        closeCallback() {
            this.resetForm();
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/Order/components/optCooperationAgreementDetails/vm.js